<app-loader
  [apiCall]="this.apiCall"
  [loader]="true"
  [loaderId]="'accountMoveCreateModal'"
  style="min-height: 150px"
>
  <form
    [formGroup]="invoiceForm"
    (ngSubmit)="onSubmit()"
    [hasUnsavedData]="invoiceForm"
  >
    <button type="submit" hidden="hidden"></button>

    <div class="row mb-2">
      <div class="col-12 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
          >CONTRACT_LBL_ACCOUNT_MOVE_TYPE</label
          >

          <div class="col">
            @if (this.insuranceClaimId()) {
              <!-- On a claim, the type is forced to "Frais de sinistre": show it read-only. -->
              <app-typeahead
                [limitToList]="true"
                [dataType]="DataType.Enum"
                [referenceEndpoint]="'Views/enum/values'"
                [referenceField]="
                'Comparanoo.Core.Enums.Accounting.InsuranceClaimAccountMoveCategory'
              "
                [valueMember]="'name'"
                [displayMember]="'name'"
                [dropdownStyle]="DropdownStyle.DropDownList"
                [controlForm]="this.invoiceForm.get('accountMoveName')"
                [showFirstElement]="true"
                [readonly]="true"
              />
            } @else {
              <app-typeahead
                [limitToList]="true"
                [dataType]="DataType.Enum"
                [referenceEndpoint]="'Views/enum/values'"
                [referenceField]="
                'Comparanoo.Core.Enums.Accounting.ContractAccountMoveCategory'
              "
                [valueMember]="'name'"
                [displayMember]="'name'"
                [dropdownStyle]="DropdownStyle.DropDownList"
                [controlForm]="this.invoiceForm.get('accountMoveName')"
                [readonly]="this.isEdit"
              />
            }
          </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
            >PAYMENT_LBL_AMOUNT
            </label>
            <div class="col">
              <input
                class="form-control form-control-sm"
                type="text"
                formControlName="invoiceAmount"
                checkFormFieldValidity
                [placeholder]="this.unitPricePlaceholder | translate"
                mask="separator.2"
                [suffix]="this.unitPriceSuffix | translate"
                [showMaskTyped]="false"
                [decimalMarker]="'.'"
                [allowNegativeNumbers]="false"
              />
            </div>
          </div>

          @if (this.isRecurringFees()) {
            <div class="form-group row">
              <label class="col-4 col-form-label-sm" translate
              >CONTRACT_LBL_ACCOUNTMOVE_PERIOD</label
              >
              <div class="col">
                <app-typeahead
                  [controlForm]="this.invoiceForm.controls['accountMovePeriod']"
                  [dataValueMember]="'name'"
                  [dropdownStyle]="DropdownStyle.DropDownList"
                  [limitToList]="true"
                  [data]="this.accountMovePeriodsModels$ | async"
                  [readonly]="this.isEdit"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label-sm" translate
              >CONTRACT_LBL_ACCOUNTMOVE_PERIOD_START_DATE</label
              >
              <div class="col">
                <input
                  class="form-control form-control-sm"
                  type="date"
                  [max]="this.maxDateMaskSafeGuard"
                  formControlName="periodStartDate"
                  checkFormFieldValidity
                  [readonly]="this.isEdit"
                />
              </div>
            </div>
          }

        </div>
        <div class="col">
          @if (this.isClient()) {
            <div class="form-group row">
              @if (this.isOverPaid()) {
                <label class="col-4 col-form-label-sm" translate>INVOICE_EXTENDED_LBL_TO_REIMBURSEMENT</label>
              } @else {
                <label class="col-4 col-form-label-sm" translate>INVOICE_EXTENDED_LBL_TO</label>
              }

              <div class="col">
                <app-typeahead
                  [routeEndpoint]="'Accounts'"
                  [controlForm]="this.invoiceForm.get('creditAccountId')"
                  [domain]="this.accountToDomain"
                  [orderBy]="'name asc'"
                  [limitToList]="true"
                  [readonly]="this.isEdit"
                />
              </div>
            </div>
          }

          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
            >INVOICE_EXTENDED_LBL_ACCOUNTMOVE_NAME</label
            >
            <div class="col">
              <input
                class="form-control form-control-sm"
                type="text"
                formControlName="invoiceNumber"
                checkFormFieldValidity
                [readonly]="this.isEdit"
                [placeholder]="'INVOICE_EXTENDED_PLACEHOLDER_ACCOUNTMOVE_NAME' | translate"
              />
            </div>
          </div>
          @if (this.isRecurringFees()) {
            <div class="form-group row invisible">
              <label class="col-4 col-form-label-sm" translate
              ></label
              >
              <div class="col">
                <input
                  class="form-control form-control-sm"
                  type="text"
                />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-4 col-form-label-sm" translate
              >CONTRACT_LBL_ACCOUNTMOVE_PERIOD_END_DATE</label
              >
              <div class="col">
                <input
                  class="form-control form-control-sm"
                  type="date"
                  [max]="this.maxDateMaskSafeGuard"
                  formControlName="periodEndDate"
                  checkFormFieldValidity
                  [readonly]="this.isEdit"
                />
              </div>
            </div>
          }

        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md">


        </div>
      </div>
      <hr/>
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <div class="form-group-title my-1" translate>INVOICE_EXTENDED_FIELDSET_PAYMENT</div>
            <div class="col align-self-center">
              <div class="form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheck"
                  formControlName="paymentChoice"
                />
                <label class="ms-1 form-check-label" for="flexSwitchCheck" translate>
                  INVOICE_EXTENDED_LBL_PAYMENT_SAVE
                </label>
              </div>
            </div>
            <div class="col-1 invisible">
              <input
                class="form-control form-control-sm"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      @if (this.invoiceForm.get('paymentChoice')?.value === true) {

        <div class="row">
          <div class="col-12 col-md">
            <div class="form-group row">
              <label class="col-4 col-form-label-sm"> {{ 'PAYMENT_LBL_MODE' | translate }}</label>
              <div class="col">
                <app-typeahead
                  [limitToList]="true"
                  [dataType]="DataType.Enum"
                  [referenceEndpoint]="'Views/enum/values'"
                  [referenceField]="'Comparanoo.Core.Enums.PaymentMode'"
                  [valueMember]="'value'"
                  [displayMember]="'name'"
                  [dropdownStyle]="DropdownStyle.DropDownList"
                  [controlForm]="this.invoiceForm.get('paymentMode')"
                  [readonly]="this.isEdit"
                ></app-typeahead>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-4 col-form-label-sm"> {{ 'PAYMENT_LBL_REFERENCE' | translate }}</label>
              <div class="col">
                <input
                  class="form-control form-control-sm"
                  type="text"
                  [placeholder]="''"
                  formControlName="paymentReference"
                  checkFormFieldValidity
                />
              </div>
            </div>


          </div>
          <div class="col">
            <div class="form-group row">
              <label class="col-4 col-form-label-sm">{{ 'PAYMENT_LBL_DATE' | translate }}</label>
              <div class="col">
                <input
                  class="form-control form-control-sm"
                  type="date"
                  [max]="this.maxDateMaskSafeGuard"
                  formControlName="paymentDate"
                  checkFormFieldValidity
                />
              </div>
            </div>
            @if (this.invoiceForm.get('paymentMode')?.value != 'Cash') {
              <div
                class="form-group row"
              >
                <label class="col-4 col-form-label-sm">{{ 'PAYMENT_LBL_PROOF' | translate }}</label>
                <div class="col">
                  <app-generic-file-input
                    [isValidationButton]="false"
                    [isClearButton]="true"
                    (fileEmitter)="onFileEmitterProof($event)"
                  />
                </div>
              </div>
            }

          </div>
        </div>

      }

      <hr/>
      <div class="row">
        <div class="col">
          <div class="form-group row">
            <div class="form-group-title my-1" translate>INVOICE_EXTENDED_FIELDSET_REPAYMENT</div>
            <div class="col align-self-center">
              <div class="form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheck1"
                  formControlName="needToCreateRepayment"
                />
                <label class="ms-1 form-check-label" for="flexSwitchCheck1" translate>
                  INVOICE_EXTENDED_LBL_REPAYMENT_SAVE
                </label>
              </div>
            </div>
            <div class="col-1 invisible">
              <input
                class="form-control form-control-sm"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
  </form>
</app-loader>
